import { z } from 'zod'

/***************** 브랜드 *****************/
export const BRAND = ['MATHFLAT', 'SCHOOLFLAT'] as const

// 앱이 어느 브랜드로 떠 있는지를 가리키는 FE 어휘다. 서버의 serviceType(ENGLISHFLAT·SCIENCEFLAT 포함)과 다르다.
export const BrandSchema = z.enum(BRAND)
export type Brand = z.infer<typeof BrandSchema>
